import {
  collection,
  doc,
  getDoc,
  getDocs,
  setDoc,
  updateDoc,
  deleteDoc,
  query,
  orderBy
} from 'firebase/firestore';
import { db } from './firebase';

/**
 * Menti Service
 * CRUD for /mentiPresentations collection
 */

export const createPresentation = async (data) => {
  try {
    const ref = doc(collection(db, 'mentiPresentations'));
    const id = ref.id;

    const processedSlides = (data.slides || []).map((slide, i) => ({
      id: slide.id || `sl${i + 1}`,
      order: i + 1,
      type: slide.type || 'content',
      title: slide.title || '',
      description: slide.description || '',
      config: slide.config || {}
    }));

    const presentation = {
      id,
      title: data.title || 'Ny presentasjon',
      description: data.description || '',
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString(),
      slides: processedSlides
    };

    await setDoc(ref, presentation);
    return presentation;
  } catch (error) {
    console.error('Error creating presentation:', error);
    throw new Error(`Klarte ikkje opprette presentasjon: ${error.message}`);
  }
};

export const getPresentation = async (presentationId) => {
  try {
    const ref = doc(db, 'mentiPresentations', presentationId);
    const snap = await getDoc(ref);
    if (!snap.exists()) throw new Error('Fann ikkje presentasjonen');
    return snap.data();
  } catch (error) {
    console.error('Error fetching presentation:', error);
    throw new Error(`Klarte ikkje hente presentasjon: ${error.message}`);
  }
};

export const updatePresentation = async (presentationId, updates) => {
  try {
    const ref = doc(db, 'mentiPresentations', presentationId);

    if (updates.slides) {
      updates.slides = updates.slides.map((slide, i) => ({
        id: slide.id || `sl${i + 1}`,
        order: i + 1,
        type: slide.type || 'content',
        title: slide.title || '',
        description: slide.description || '',
        config: slide.config || {}
      }));
    }

    await updateDoc(ref, { ...updates, updatedAt: new Date().toISOString() });
  } catch (error) {
    console.error('Error updating presentation:', error);
    throw new Error(`Klarte ikkje oppdatere presentasjon: ${error.message}`);
  }
};

export const deletePresentation = async (presentationId) => {
  try {
    await deleteDoc(doc(db, 'mentiPresentations', presentationId));
  } catch (error) {
    console.error('Error deleting presentation:', error);
    throw new Error(`Klarte ikkje slette presentasjon: ${error.message}`);
  }
};

export const getAllPresentations = async () => {
  try {
    const q = query(collection(db, 'mentiPresentations'), orderBy('updatedAt', 'desc'));
    const snapshot = await getDocs(q);
    const results = [];
    snapshot.forEach((d) => results.push({ id: d.id, ...d.data() }));
    return results;
  } catch (error) {
    console.error('Error fetching presentations:', error);
    throw new Error(`Klarte ikkje hente presentasjonar: ${error.message}`);
  }
};
